import MuiAvatar, { AvatarProps } from "@mui/material/Avatar";
import { TypographyVariants, useTheme } from "@mui/material/styles";
import { AVATAR_PIXEL_SIZE_UNIT, AVATAR_SIZE_MAP, IAvatarSize } from "src/components-mui/base/avatar/avatar.constants";
import { toResponsiveValue } from "src/components-mui/base/avatar/avatar.utils";
import { TRADER_AVATAR_INITIALS_TEST_ID } from "src/components-mui/base/avatar/initials-avatar.test-ids";

const INITIALS_FONT_FAMILY = "Arial";

const TYPOGRAPHY_TOKEN_BY_AVATAR_SIZE: Record<IAvatarSize, keyof Pick<TypographyVariants, "2xs" | "xs" | "md" | "xl" | "2xl" | "3xl">> = {
    "2xs": "2xs",
    xs: "xs",
    sm: "md",
    md: "xl",
    lg: "xl",
    xl: "2xl",
    "2xl": "3xl",
};

export interface IInitialsAvatarProps extends Omit<AvatarProps, "children" | "sx"> {
    size: IAvatarSize | IAvatarSize[];
    firstName: string;
    lastName: string;
    bg: string;
}

export const InitialsAvatar = ({ size, firstName, lastName, bg, ...rest }: IInitialsAvatarProps) => {
    const theme = useTheme();
    const initials = `${firstName.substring(0, 1)}${lastName.substring(0, 1)}`;

    const containerPixelSize = toResponsiveValue(size, value => `${AVATAR_SIZE_MAP[value] * AVATAR_PIXEL_SIZE_UNIT}px`);
    const fontSize = toResponsiveValue(size, value => theme.typography[TYPOGRAPHY_TOKEN_BY_AVATAR_SIZE[value]]);

    return (
        <MuiAvatar
            {...rest}
            data-test-id={TRADER_AVATAR_INITIALS_TEST_ID}
            sx={{
                width: containerPixelSize,
                height: containerPixelSize,
                bgcolor: bg,
                color: theme.palette.common.white,
                fontFamily: INITIALS_FONT_FAMILY,
                fontWeight: theme.typography.fontWeightSemibold,
                fontSize,
                lineHeight: containerPixelSize,
                textTransform: "uppercase",
            }}
        >
            {initials}
        </MuiAvatar>
    );
};
